import React, {useEffect} from 'react';
import {Container, Content, ContentFooter, ContentHeader} from './PdfViewer.styles';
import Spinner from '../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/Spinner/Spinner';
const PdfViewer = ({
  pdfSrc,
  approveInvoicePdf,
  showLoader,
  showContinue = true,
  errorMsg,
  setErrorMsg,
}) => {
  const handleApprove = () => {
    approveInvoicePdf && approveInvoicePdf();
  };
  useEffect(() => {
    return () => {
      setErrorMsg('');
    };
  }, []);

  return (
    <Container>
      <ContentHeader>
        <Content>
          <embed src={pdfSrc}></embed>
        </Content>
      </ContentHeader>
      <ContentFooter>
        <span className="fs10 latoBlack blueText">UPLOAD - PREVIEW</span>
        <div className="flex hCenter">
          {/*<a className="fs12 mr10 blueText">Upload Again</a>*/}
          {showLoader ? (
            <Spinner width="32px" height="32px" borderWidth="4px" />
          ) : (
            <>
              {showContinue && !errorMsg && <button onClick={handleApprove}>Continue</button>}
              {errorMsg && (
                <p
                  style={{
                    color: 'red',
                  }}
                >
                  {errorMsg}
                </p>
              )}
            </>
          )}
        </div>
      </ContentFooter>
    </Container>
  );
};

export default PdfViewer;
